var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharepoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 191,
    viewBox: "0 0 192 191",
    id: "sharepoint",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: "134.5%",
    height: "134.5%",
    x: "-17.3%",
    y: "-17.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner2",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: -1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    width: "101%",
    height: "101%",
    x: "-.5%",
    y: "-.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.16 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    width: "109.1%",
    height: "109.1%",
    x: "-3.2%",
    y: "-5.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0.815686275   0 0 0 0 0.862745098  0 0 0 0.53 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    width: "111.7%",
    height: "111.7%",
    x: "-4.5%",
    y: "-7.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    width: "117%",
    height: "117%",
    x: "-8.5%",
    y: "-8.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("filter", {
    id: "z",
    width: "103.1%",
    height: "103.1%",
    x: "-1.6%",
    y: "-1.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1",
    values: "0 0 0 0 0   0 0 0 0 0.619607843   0 0 0 0 0.643137255  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    result: "shadowBlurInner2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2",
    values: "0 0 0 0 0.0823529412   0 0 0 0 0.450980392   0 0 0 0 0.462745098  0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "B",
    width: "155.7%",
    height: "137%",
    x: "-27.8%",
    y: "-16.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "12.751%",
    x2: "90.236%",
    y1: "8.186%",
    y2: "92.889%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#004548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#03696D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "3.577%",
    x2: "95.264%",
    y1: "14.813%",
    y2: "92.069%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00979E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00D7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: "6.294%",
    x2: "78.82%",
    y1: "0%",
    y2: "89.692%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#08CBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E5F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: "2.151%",
    x2: "113.177%",
    y1: "9.713%",
    y2: "104.673%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#004F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.164%",
    stopColor: "#007C7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: "29.468%",
    x2: "97.963%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 512,
    height: 512,
    x: -512,
    y: -512,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "k",
    width: 512,
    height: 512,
    x: -451,
    y: -455,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "p",
    width: 512,
    height: 512,
    x: -488,
    y: -399,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "x",
    width: 512,
    height: 512,
    x: -512,
    y: -512,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "f",
    cx: 56.5,
    cy: 56.5,
    r: 56.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "j",
    cx: 109.5,
    cy: 105.5,
    r: 48.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "n",
    cx: 62.5,
    cy: 151.5,
    r: 38.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "u",
    width: 96,
    height: 96,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "A",
    width: 96,
    height: 98,
    y: -1,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M61.578057,113.010822 C61.5660039,112.933294 61.5541344,112.855704 61.5424491,112.778054 C59.8812436,112.924974 58.1993834,113 56.5,113 C25.2959116,113 0,87.7040884 0,56.5 C0,25.2959116 25.2959116,0 56.5,0 C87.7040884,0 113,25.2959116 113,56.5 C113,56.7083023 112.998873,56.9163414 112.996624,57.1241114 C138.150291,58.9160926 158,79.8899724 158,105.5 C158,132.28581 136.28581,154 109.5,154 C106.586493,154 103.732989,153.743099 100.960903,153.250713 C100.045659,173.701114 83.1762339,190 62.5,190 C41.2370371,190 24,172.762963 24,151.5 C24,130.545211 40.7410101,113.500494 61.578057,113.010822 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M31.2080078,70.6391602 L31.2080078,60.5454102 C33.3201904,61.8063965 35.4028202,62.4979613 37.7602539,63.3415527 C40.1176876,64.1851442 42.4981976,64.6069336 44.9018555,64.6069336 C46.3116932,64.6069336 49.5423938,64.479819 50.5939941,64.2255859 C51.6455945,63.9713529 52.5238409,63.6188987 53.2287598,63.1682129 C53.9336787,62.717527 54.4594709,62.1859568 54.8061523,61.5734863 C55.1528338,60.9610158 55.3261719,60.2965531 55.3261719,59.5800781 C55.3261719,58.6093701 55.0488309,57.7426796 54.4941406,56.9799805 C53.9394504,56.2172813 53.1825406,55.512373 52.2233887,54.8652344 C51.2642367,54.2180957 50.1259831,53.5940785 48.8085938,52.9931641 C47.4912044,52.3922496 44.182991,51.0185578 42.6575928,50.3945313 C38.7747609,48.7766846 35.7668552,47.1164261 33.8601074,44.7821045 C31.9533596,42.4477829 31,40.0735842 31,36.7685547 C31,34.1800001 31.5200143,31.9554943 32.5600586,30.0949707 C33.6001029,28.2344471 35.0156974,26.7032938 36.8068848,25.5014648 C38.5980721,24.2996359 40.6723515,23.4156116 43.0297852,22.8493652 C45.3872188,22.2831189 47.8832876,22 50.5180664,22 C53.106621,22 55.400462,22.1560043 57.3996582,22.4680176 C59.3988544,22.7800309 62.2420163,23.2595996 63.9291992,23.9067383 L63.9291992,33.2724609 C61.6118164,32.3728027 57.2143607,30.9439305 56.1743164,30.6550293 C55.1342721,30.3661281 54.1000214,30.1523444 53.0715332,30.0136719 C52.043045,29.8749993 51.0665736,29.8056641 50.1420898,29.8056641 C48.8709246,29.8056641 47.7153372,29.9270007 46.675293,30.1696777 C45.6352487,30.4123547 44.7570023,30.753253 44.0405273,31.1923828 C43.3240524,31.6315126 42.7693705,32.1573049 42.3764648,32.7697754 C41.9835592,33.3822459 41.7731934,34.6325645 41.7731934,35.3952637 C41.7731934,36.2272991 42.006671,37.4099088 42.4458008,38.0686035 C42.8849306,38.7272982 43.5089478,39.3513154 44.3178711,39.9406738 C45.1267944,40.5300322 46.1090437,41.1078259 47.2646484,41.6740723 C48.4202532,42.2403186 50.7260669,42.8238902 52.1821289,43.4248047 C54.1697691,44.2568401 55.9551516,45.1408645 57.5383301,46.0769043 C59.1215086,47.0129441 60.4793238,48.0703066 61.6118164,49.2490234 C62.744309,50.4277403 63.6109996,51.7739996 64.2119141,53.2878418 C64.8128285,54.801684 65.1132812,56.5639548 65.1132812,58.574707 C65.1132812,61.3481584 64.587489,63.676667 63.5358887,65.5603027 C62.4842884,67.4439385 61.0571379,68.9693138 59.2543945,70.1364746 C57.4516511,71.3036354 55.35426,72.1414363 52.9621582,72.6499023 C50.5700564,73.1583684 48.0450979,73.4125977 45.387207,73.4125977 C42.6599799,73.4125977 40.0656861,73.1814802 37.604248,72.7192383 C35.14281,72.2569964 33.0107512,71.5636439 31.2080078,70.6391602 Z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: "86.601%",
    cy: "84.21%",
    r: "62.398%",
    fx: "86.601%",
    fy: "84.21%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "2.414%",
    stopColor: "#047B7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "97.706%",
    stopColor: "#007C7E",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    fill: "url(#g)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    fill: "#000",
    filter: "url(#h)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    fill: "url(#k)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    fill: "#000",
    filter: "url(#l)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    fill: "#000",
    filter: "url(#m)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    fill: "url(#p)",
    fillOpacity: 0.012
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    fill: "#000",
    filter: "url(#q)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M-26,48 L54,48 C58.418278,48 62,51.581722 62,56 L62,136 C62,140.418278 48.418278,154 44,154 L-36,154 C-40.418278,154 -44,150.418278 -44,146 L-44,66 C-44,61.581722 -30.418278,48 -26,48 Z",
    filter: "url(#s)",
    mask: "url(#t)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 47)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "y",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    fill: "url(#v)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u",
    fill: "url(#x)",
    fillOpacity: 0.013
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#y)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    filter: "url(#z)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#y)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    fill: "#000",
    filter: "url(#B)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    fill: "url(#D)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharepoint);
export default __webpack_public_path__ + "static/media/sharepoint.a3750f2421b08a6e95301455ba410a3a.svg";
export { ForwardRef as ReactComponent };